import React, { useState } from 'react';
import CalendarTodayOutlined from '@mui/icons-material/CalendarTodayOutlined';
import AddCircleOutlineOutlined from '@mui/icons-material/AddCircleOutlineOutlined';
import InboxOutlined from '@mui/icons-material/InboxOutlined';
import StorefrontOutlined from '@mui/icons-material/StorefrontOutlined';
import BarChartOutlined from '@mui/icons-material/BarChartOutlined';
import GroupOutlined from '@mui/icons-material/GroupOutlined';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

const services = [
    {
        name: 'إدارة المواعيد الذكية',
        icon: <CalendarTodayOutlined fontSize="small" />,
        image: '/assets/booking.jpg',
        description: 'من خلال منصة WNVR يمكنك حجز المواعيد وإدارتها بكل سهولة ودقة دون الحاجة للانتظار.',
    },
    {
        name: 'لوحة تحكم الفروع',
        icon: <StorefrontOutlined fontSize="small" />,
        image: '/assets/branches.jpg',
        description: 'أنشئ وأدر فروع مؤسستك بسهولة مع إمكانيات مخصصة لكل فرع.',
    },
    {
        name: 'حجز الدور الفوري',
        icon: <AddCircleOutlineOutlined fontSize="small" />,
        image: '/assets/queue.jpg',
        description: 'وفّر على عملائك الوقت من خلال حجز الدور الإلكتروني المباشر.',
    },
    {
        name: 'تنظيم واستقبال الحجوزات',
        icon: <InboxOutlined fontSize="small" />,
        image: '/assets/inbox.jpg',
        description: 'استقبل ونظّم جميع الحجوزات في مكان واحد يسهل متابعته.',
    },
    {
        name: 'تحليلات دقيقة للبيانات',
        icon: <BarChartOutlined fontSize="small" />,
        image: '/assets/stats.jpg',
        description: 'احصل على تقارير وبيانات تساعدك على اتخاذ قرارات أفضل.',
    },
    {
        name: 'إدارة الموظفين',
        icon: <GroupOutlined fontSize="small" />,
        image: '/assets/staff.jpg',
        description: 'تابع أداء موظفيك ونظّم مهامهم بدقة وكفاءة عالية.',
    },
];

const LandingPage = () => {
    const [activeService, setActiveService] = useState(services[0]);
    const navigate = useNavigate();

    const handleGoToSignup = () => {
        navigate('/signup');
    };

    return (
        <div className='page-container'>
            <div className="hero-container">
                <div className="hero-text-block">
                    <h1 className="hero-title">
                        وداعًا للفوضى والانتظار، وابدأ <span className="highlight">إدارة ذكية</span>
                    </h1>
                    <p className="hero-text">
                        انضم إلى WNVR لإدارة المواعيد والأدوار بكفاءة عالية وتحسين تجربة عملائك من خلال نظام ذكي وسهل الاستخدام.
                    </p>
                    <button className="btn filled" onClick={handleGoToSignup}>ابدأ الآن</button>
                </div>
                <img src="/assets/landing.png" alt="Landing Visual" className="hero-img" />
            </div>

            <div className="services-container">
                <div className="image-side">
                    <div className="image-box">
                        <img src={activeService.image} alt={activeService.name} className="preview-img" />
                        <p className="preview-desc">{activeService.description}</p>
                    </div>
                </div>

                <div className="list-side">
                    {services.map((service) => (
                        <div
                            key={service.name}
                            onClick={() => setActiveService(service)}
                            className={`service-item ${activeService.name === service.name ? 'active' : ''}`}
                        >
                            <span className="icon">{service.icon}</span>
                            <span className="service-title">{service.name}</span>
                        </div>
                    ))}
                </div>
            </div>

            <div className="stats-section">
                <h2 className="section-title">أرقام تميزنا</h2>
                <div className="stats-grid">
                    <div className="stat-card"><strong>+50,000</strong><span>موعد شهري</span></div>
                    <div className="stat-card"><strong>99.9%</strong><span>رضا العملاء</span></div>
                    <div className="stat-card"><strong>+10,000</strong><span>مستخدم نشط</span></div>
                    <div className="stat-card"><strong>4.9/5</strong><span>تقييم المنصة</span></div>
                </div>
            </div>

            <div className="how-section">
                <h2 className="section-title">كيف يعمل WNVR؟</h2>
                <p className="section-subtext">آلية ذكية تسهّل العمل وتُسرّع تقديم الخدمات</p>
                <div className="steps-grid">
                    <div className="step-box">سجّل مؤسستك بسهولة</div>
                    <div className="step-box">أنشئ الفروع والخدمات</div>
                    <div className="step-box">ابدأ باستقبال الحجوزات</div>
                    <div className="step-box">راقب الأداء وطوّر خدماتك</div>
                </div>
            </div>

            <div className="cta-section">
                <h2>جاهز للانتقال إلى مستوى جديد من الإدارة؟</h2>
                <p>انضم إلى آلاف المؤسسات التي تثق بـ WNVR</p>
                <button className="btn filled" onClick={handleGoToSignup}>ابدأ مجانًا الآن</button>
            </div>
        </div>
    );
};

export default LandingPage;